import { Paper, PaperProps, Typography } from '@mui/material';
import { TranslationWithHtml } from 'components/text/TranslationWithHtml';
import { useTranslator } from 'translation/useTranslator';

interface SearchNotFoundProps extends PaperProps {
  searchQuery?: string;
}

export default function SearchNotFound({ searchQuery = '', ...other }: SearchNotFoundProps) {
  const translator = useTranslator();
  return (
    <Paper {...other}>
      <Typography gutterBottom align="center" variant="subtitle1">
        {translator.notFound()}
      </Typography>

      <TranslationWithHtml
        translation={translator.noSearchResults(searchQuery)}
        variant="body2"
        align="center"
      />
    </Paper>
  );
}
